import { render } from "./ConfirmLogout.vue?vue&type=template&id=0ca6be74&scoped=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=0ca6be74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca6be74"]])

export default __exports__